/**
 * Created by cc on 2016/10/20 0020.
 */
'use strict';
const Flow = require('eme-flow');
Flow.set(sails.config.envs.mysql);
module.exports = Flow.controller;